// Single source of truth for brand content, photos, rooms, and translations.
// Replace Unsplash/Pexels URLs with your own uploaded photos later.

export const BRAND = {
  name: "Guesthouse Bambou Beach",
  logo: "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/75l74iif_ghbb%20logo%20500x500.png",
  whatsapp: "+229 01 69 16 28 76",
  whatsappIntl: "22901691628 76".replace(/\s/g, ""), // for wa.me
  waNumberClean: "22901691628 76".replace(/\s/g, ""),
  phone: "+229 01 69 16 28 76",
  email: "reservation@guesthousebamboubeach.com",
  address: {
    quartier: "Ayi-Guinnou",
    commune: "Grand-Popo",
    arrondissement: "Agoué",
    country: "Bénin",
  },
  googleMaps: "https://goo.gl/maps/tZqegtTEJtYGdsnN6",
  bookingCom:
    "https://www.booking.com/hotel/bj/guesthouse-bambou-beach.html",
  airbnb: "https://www.airbnb.com/",
  website: "https://www.guesthousebamboubeach.com",
};

// wa.me expects number without +, spaces, or leading zero after country code
export const WA_LINK = `https://wa.me/${BRAND.whatsapp.replace(/\D/g, "")}`;

export const ROOMS = [
  {
    id: "patio",
    nameFr: "Chambre Patio",
    nameEn: "Patio Room",
    priceFrom: 66,
    priceTo: null,
    image:
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/3kr65zvo_20221014_172123.jpg",
    extraImages: [
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/ct86hci0_Chambre%20Patio%201.jpg",
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/netw9xwd_20221014_172141.jpg",
    ],
    featuresFr: [
      "Lit double",
      "Climatisation",
      "Salle de bain privée",
      "Wi-Fi gratuit",
    ],
    featuresEn: [
      "Double bed",
      "Air conditioning",
      "Private bathroom",
      "Free Wi-Fi",
    ],
    descFr:
      "Chambre double spacieuse, baignée d'une lumière douce, avec accès privatif à un patio calme. Climatisée, elle est pensée pour une nuit paisible après une journée au bord de l'océan.",
    descEn:
      "Spacious double bedroom, bathed in soft light, with private access to a quiet patio. Air-conditioned — designed for a peaceful night after a day by the ocean.",
  },
  {
    id: "ocean",
    nameFr: "Chambre Ocean",
    nameEn: "Ocean Room",
    priceFrom: 66,
    priceTo: null,
    image:
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/tuw1ihc0_20220906_094257.jpg",
    extraImages: [
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/cv659drl_20230626_123136%20%281%29.jpg",
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/qvu0d0c5_20230626_123859.jpg",
    ],
    featuresFr: [
      "Lit double",
      "Climatisation",
      "Vue sur la mer",
      "Wi-Fi gratuit",
    ],
    featuresEn: ["Double bed", "Air conditioning", "Sea view", "Free Wi-Fi"],
    descFr:
      "Notre chambre signature. Vue directe sur l'océan, climatisation, lumière dorée au lever du soleil. Idéale pour les voyageurs qui veulent s'endormir au son des vagues.",
    descEn:
      "Our signature room. Direct ocean view, air conditioning, golden light at sunrise. Perfect for travelers who want to fall asleep to the sound of waves.",
  },
  {
    id: "tintin",
    nameFr: "Chambre Tintin",
    nameEn: "Tintin Room",
    priceFrom: 50,
    priceTo: null,
    image:
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/amwjv7jm_chambre%20lit%20tintin.jpg",
    extraImages: [
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/14xzhtn4_chambre%20tintin.jpg",
    ],
    featuresFr: [
      "Lit double",
      "Ventilée",
      "Rez-de-chaussée",
      "Wi-Fi gratuit",
    ],
    featuresEn: ["Double bed", "Fan", "Ground floor", "Free Wi-Fi"],
    descFr:
      "Chambre double spacieuse au rez-de-chaussée, ventilée. Parfaite pour les voyageurs qui préfèrent la brise naturelle et un accès direct au jardin.",
    descEn:
      "Spacious ground-floor double bedroom, ventilated. Perfect for travelers who prefer the natural breeze and direct access to the garden.",
  },
  {
    id: "sosso",
    nameFr: "Chambre Sosso",
    nameEn: "Sosso Room",
    priceFrom: 53,
    priceTo: null,
    image:
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/evp00082_a.jpg",
    extraImages: [
      "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/q3pf315s_bett2.jpg",
    ],
    featuresFr: [
      "Lit double + lit simple",
      "Ventilée",
      "Spacieuse et aérée",
      "Wi-Fi gratuit",
    ],
    featuresEn: ["Double bed + single bed", "Fan", "Spacious and airy", "Free Wi-Fi"],
    descFr:
      "Chambre double spacieuse et aérée au rez-de-chaussée, ventilée. Un cocon simple et lumineux, pensé pour le repos.",
    descEn:
      "Spacious and airy ground-floor double bedroom, ventilated. A simple, luminous cocoon designed for rest.",
  },
];

export const GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/we2h60so_20220902_151513.jpg",
    alt: "Vue océan depuis la plage de Bambou Beach — Grand-Popo, Bénin",
    tall: true,
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/zygl3sl3_c1.jpg",
    alt: "Espace extérieur en bambou, accès plage",
    tall: true,
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/blrxy1qz_f.jpg",
    alt: "Terrasse ombragée entre les palmiers",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/4zkofgib_d.jpg",
    alt: "Salon extérieur sous la paillote",
  },
];

export const HOST = {
  name: "Jacky",
  image:
    "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/rdij2yeh_ChatGPT%20Image%20Apr%2027%2C%202026%2C%2008_08_46%20PM.png",
};

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/we2h60so_20220902_151513.jpg";

export const BUILDING_IMAGE =
  "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/05mgu45b_a.JPG";

export const SECONDARY_IMAGE =
  "https://customer-assets.emergentagent.com/job_bambou-beach-booking/artifacts/4zkofgib_d.jpg";
